import React, { useState } from 'react';
import { Row, Stack, Title } from 'library/ui';
import { ITeacher } from 'models';
import { useClient } from 'shared';
import { PermissionType, useUserContext } from 'UserContext';
import ShowcaseTeacherRow from './ShowcaseTeacherRow';
import InviteButton from './InviteButton';
import ViewMoreTeachers from './ViewMoreTeachers';
import { BasicCard } from './BasicCard';

interface ITeacherShowcase {
    workers: ITeacher[];
}

export function TeacherShowcase() {
    const { data, error, loading } = useClient<ITeacherShowcase>({ url: 'api/dashboard/worker-spotlight/' });
    const [selectedWorkers, setSelectedWorkers] = useState<ITeacher[]>([]);
    const { hasPermission } = useUserContext();
    const canPostJobs = hasPermission(PermissionType.PostJob);

    function toggleSelected(worker: ITeacher) {
        if (selectedWorkers.some((sw) => sw.id === worker.id)) {
            setSelectedWorkers(selectedWorkers.filter((x) => x.id !== worker.id));
        } else {
            setSelectedWorkers([...selectedWorkers, worker]);
        }
    }

    if (error || data?.workers?.length === 0 || loading) return null;

    return (
        <BasicCard loading={loading}>
            <Stack gap="md">
                <Row justify="between" wrap gap="md">
                    <Title size="h2">Available Tandem Teachers</Title>
                    {canPostJobs && (
                        <InviteButton selectedWorkers={selectedWorkers} setSelectedWorkers={setSelectedWorkers} />
                    )}
                </Row>
                <Stack gap="sm">
                    {data?.workers?.map((worker: ITeacher) => (
                        <ShowcaseTeacherRow
                            key={worker.id}
                            worker={worker}
                            selected={selectedWorkers.some((sw) => sw.id === worker.id)}
                            onChange={toggleSelected}
                            showcaseHighlight
                        />
                    ))}
                </Stack>
                <Row justify="end">
                    <ViewMoreTeachers showcaseWorkers={data?.workers} />
                </Row>
            </Stack>
        </BasicCard>
    );
}
